import {
  ActivityLevel,
  AgeCategory,
  AnimalType,
  BodyCondition,
  DietType,
  DogFormData,
  Pathology,
  Protein,
} from '../types';

/**
 * Build a DogFormData payload from partial form state, applying safe defaults.
 * Used by Step13 (pricing preview) and Step14 (checkout).
 */
export function buildApiPayload(formData: Partial<DogFormData>, overrides?: Partial<DogFormData>): DogFormData {
  return {
    animalType: formData.animalType || AnimalType.PERRO,
    nombre: formData.nombre || 'Perro',
    raza: formData.raza || 'Mestizo',
    ageCategory: formData.ageCategory || AgeCategory.ADULTO,
    ageYears: formData.ageYears ?? 3,
    ageMonths: formData.ageMonths ?? 0,
    ageTotalMonths: formData.ageTotalMonths ?? 36,
    peso: formData.peso ?? 10,
    bodyCondition: formData.bodyCondition || BodyCondition.IDEAL,
    activityLevel: formData.activityLevel || ActivityLevel.MEDIO,
    isNeutered: formData.isNeutered ?? false,
    pathologies: formData.pathologies || [Pathology.NINGUNA],
    subPathologies: formData.subPathologies,
    otherPathologyText: formData.otherPathologyText,
    proteinAllergies: formData.proteinAllergies || [Protein.NINGUNA],
    dietType: formData.dietType || DietType.COMPLETA,
    subscriptionStart: formData.subscriptionStart,
    selectedRecipes: formData.selectedRecipes || [],
    sizeChoice: formData.sizeChoice,
    recipeEnergyDistribution: formData.recipeEnergyDistribution,
    currentFood: formData.currentFood,
    appetiteType: formData.appetiteType,
    // Sin placeholder inventado: /calculate-plan acepta email ausente y
    // email-validator>=2 rechazaba `no-reply@miloylola.invalid` (TLD
    // reservado) → 422 permanente en Step11/12/checkout (bug 2026-06-10).
    // /calculate (persiste) solo se llama desde el submit, con email real.
    email: formData.email || undefined,
    acceptsMarketing: formData.acceptsMarketing ?? true,
    platform: formData.platform,
    informative: formData.informative,
    ...overrides,
  };
}
